import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, products } from '@/mocks/products';

const productImageUrls: Record<string, string> = {
  'p001': 'https://readdy.ai/api/search-image?query=Single%20portable%20warming%20patch%20product%20on%20clean%20light%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20warm%20lighting%2C%20modern%20packaged%20heating%20pad%20design%2C%20professional%20commercial%20product%20shot%2C%20simple%20elegant%20composition%2C%20warm%20amber%20tones&width=600&height=600&seq=cat-p001&orientation=squarish',
  'p002': 'https://readdy.ai/api/search-image?query=Large%20size%20intensive%20heating%20patch%20product%20on%20minimal%20warm%20beige%20backdrop%2C%20clean%20studio%20product%20photography%2C%20soft%20directional%20light%2C%20modern%20packaging%20with%20warm%20orange%20accents%2C%20professional%20commercial%20shot%2C%20simple%20composition&width=600&height=600&seq=cat-p002&orientation=squarish',
  'p003': 'https://readdy.ai/api/search-image?query=Elegant%20portable%20rechargeable%20hand%20warmer%20on%20soft%20cream%20surface%2C%20minimalist%20product%20photography%2C%20warm%20ambient%20lighting%2C%20sleek%20modern%20design%20in%20warm%20tones%2C%20professional%20commercial%20shot%2C%20clean%20composition%20with%20soft%20shadows&width=600&height=600&seq=cat-p003&orientation=squarish',
  'p004': 'https://readdy.ai/api/search-image?query=Professional%20heated%20vest%20outdoor%20winter%20gear%20on%20clean%20warm%20background%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20technical%20outdoor%20apparel%20design%2C%20professional%20commercial%20shot%2C%20warm%20tones%20with%20technical%20aesthetic&width=600&height=600&seq=cat-p004&orientation=squarish',
  'p005': 'https://readdy.ai/api/search-image?query=Smart%20heated%20insoles%20product%20on%20minimal%20cream%20backdrop%2C%20clean%20studio%20product%20photography%2C%20soft%20warm%20lighting%2C%20modern%20technical%20design%2C%20professional%20commercial%20shot%2C%20simple%20elegant%20composition&width=600&height=600&seq=cat-p005&orientation=squarish',
  'p006': 'https://readdy.ai/api/search-image?query=Portable%20outdoor%20heater%20fan%20product%20on%20clean%20warm%20beige%20background%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20compact%20design%20with%20warm%20accents%2C%20professional%20commercial%20shot%2C%20clean%20composition&width=600&height=600&seq=cat-p006&orientation=squarish',
  'p007': 'https://readdy.ai/api/search-image?query=Elegant%20carbon%20fiber%20heated%20scarf%20product%20on%20minimal%20warm%20cream%20surface%2C%20clean%20studio%20product%20photography%2C%20soft%20ambient%20lighting%2C%20stylish%20modern%20winter%20accessory%20design%2C%20professional%20commercial%20shot%2C%20warm%20tones%20composition&width=600&height=600&seq=cat-p007&orientation=squarish',
  'p008': 'https://readdy.ai/api/search-image?query=Ergonomic%20waist%20warming%20patch%20product%20on%20clean%20light%20cream%20background%2C%20minimalist%20product%20photography%2C%20soft%20warm%20lighting%2C%20modern%20curved%20heating%20pad%20design%2C%20professional%20commercial%20shot%2C%20simple%20composition&width=600&height=600&seq=cat-p008&orientation=squarish',
  'p009': 'https://readdy.ai/api/search-image?query=Premium%20heated%20gloves%20product%20on%20minimal%20warm%20beige%20backdrop%2C%20clean%20studio%20product%20photography%2C%20soft%20directional%20lighting%2C%20modern%20outdoor%20winter%20gear%20design%2C%20professional%20commercial%20shot%2C%20warm%20tones&width=600&height=600&seq=cat-p009&orientation=squarish',
  'p010': 'https://readdy.ai/api/search-image?query=Cozy%20USB%20powered%20foot%20warmer%20product%20on%20clean%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20warm%20ambient%20lighting%2C%20comfortable%20plush%20design%20in%20warm%20tones%2C%20professional%20commercial%20shot%2C%20clean%20elegant%20composition&width=600&height=600&seq=cat-p010&orientation=squarish',
};

const categoriesJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': 'https://rejiujiu.com/categories/#webpage',
      url: 'https://rejiujiu.com/categories',
      name: '热久久产品中心 - 保暖贴 · 户外取暖 · 冬季装备',
      isPartOf: { '@id': 'https://rejiujiu.com/#website' },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://rejiujiu.com' },
          { '@type': 'ListItem', position: 2, name: '产品中心', item: 'https://rejiujiu.com/categories' },
        ],
      },
    },
  ],
};

export default function Categories() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || categories[0]?.id || 'warming-patches';
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl && categories.some((c) => c.id === tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeTab]);

  const filteredProducts = products.filter((p) => p.categoryId === activeTab);
  const activeCategory = categories.find((c) => c.id === activeTab);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categoriesJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <section className="py-10 md:py-14 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-[1280px] mx-auto">
                <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
                  <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
                  <i className="ri-arrow-right-s-line"></i>
                  <span className="text-foreground-700 font-medium whitespace-nowrap">产品中心</span>
                </nav>

                <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
                  产品中心
                </h1>
                <p className="text-sm md:text-base text-foreground-600 mb-8">
                  探索热久久全系列保暖产品，找到最适合您的温暖方案
                </p>

                <div className="flex flex-wrap gap-2 mb-10">
                  {categories.map((cat) => (
                    <button
                      key={cat.id}
                      onClick={() => setActiveTab(cat.id)}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                        activeTab === cat.id
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-50 text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70 border border-background-200/70'
                      }`}
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>

                {activeCategory && filteredProducts.length > 0 && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-product-shop>
                    {filteredProducts.map((product) => {
                      const imgUrl = productImageUrls[product.id] || '';
                      return (
                        <div
                          key={product.id}
                          className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
                        >
                          <div className="aspect-square overflow-hidden bg-background-100">
                            <img
                              src={imgUrl}
                              alt={`热久久${product.name}`}
                              title={`热久久${product.name} - 持久保暖产品`}
                              className="w-full h-full object-cover object-top"
                            />
                          </div>
                          <div className="p-4">
                            <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{product.name}</h3>
                            <p className="text-xs text-foreground-600 mb-2 line-clamp-2">{product.description}</p>
                            <div className="flex flex-wrap gap-1.5 mb-3">
                              {product.features.slice(0, 3).map((f, i) => (
                                <span key={i} className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap">
                                  {f}
                                </span>
                              ))}
                            </div>
                            <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                              <span className="text-base font-bold text-accent-600 whitespace-nowrap">
                                &yen;{product.price}
                              </span>
                              <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                                热久久{product.name.split('热久久')[1] || product.name}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {filteredProducts.length === 0 && (
                  <div className="text-center py-20">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-200 flex items-center justify-center">
                      <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                    </div>
                    <p className="text-foreground-500">该分类暂无产品</p>
                  </div>
                )}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}